import flow from "lodash/fp/flow";
import map from "lodash/fp/map";
import identity from "lodash/fp/identity";
import moment from "moment";
import constants from "../../core/constants";

class DispatcherPageTransform {
  constructor() {
    "ngInject";

    this.ridesFields = [
      { name: "route", title: "Route" },
      { name: "date", title: "Date", isSortable: true },
      { name: "captain", title: "Captain" },
      { name: "bus", title: "Bus", value: "plates" },
      { name: "bus_type", title: "Bus Type" },
      { name: "status", title: "Status" },
    ];

    this.scheduleFields = [
      { name: "route", title: "Route" },
      { name: "captain", title: "Captain" },
      { name: "bus_type", title: "Bus Type" },
      { name: "time", title: "Time" },
    ];

    this.logFields = [{ name: "description", title: "Description" }];

    this.inQueueSchedulesFields = [
      { name: "route", title: "Route" },
      { name: "city", title: "City" },
      { name: "captain", title: "Captain" },
      { name: "bus_type", title: "Bus Type" },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);

      return item;
    };

    return flow([format, identity])(data);
  }

  justifySchedule(data) {
    const format = (item) => {
      item.time = moment(item.time).format(constants.timeFormat);

      return item;
    };

    return map(format)(data);
  }

  justifyInQueueSchedule(data) {
    const format = (item) => {
      item.route = item.route.name;
      item.city = item.city.name;
      item.captain = item.captain.name;
      item.bus_type = item.bus_type.name;
      return item;
    };

    return map(format)(data);
  }
}

export default DispatcherPageTransform;



// WEBPACK FOOTER //
// ./src/pages/dispatcher/dispatcher.transforms.js